import { render, staticRenderFns } from "./IncidentInstallments.vue?vue&type=template&id=6b724487&"
import script from "./IncidentInstallments.vue?vue&type=script&lang=js&"
export * from "./IncidentInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports